module.exports = __webpack_public_path__ + "img/teacherItem.da82dd9b.png";